export default `id
token
date
price
currency
duration
business
staff
customer
service
answers
clientTimezone
hangoutLink
locationType
locationValue
rrule
addToGoogleUrl
addToOutlookUrl
icsFileContent
paymentProvider
paymentId
approved
pendingPayment`
